import COLORS from '@/constants/colors';
import { Typography } from '@mui/material';
import { HelperTextType } from '../FormItem/FormItem.utils';

export default function InputHelperText({
  message,
  helperTextType,
}: {
  message: string;
  helperTextType: HelperTextType;
}) {
  const textColor =
    helperTextType === HelperTextType.Error
      ? COLORS.flowkit.red
      : COLORS.gray_600;
  return (
    <Typography
      sx={{
        fontSize: '12px',
        color: textColor,
        mt: '3px',
        ml: '2px',
      }}
    >
      {message}
    </Typography>
  );
}
